import { HttpClient } from "@angular/common/http";
import { AppComponent } from "../app.component";

import { BdtResources } from "../utils/models/bdt-resources.enum";
import { MasterType } from "../utils/models/master-type.enum";
import { GenericRepository } from "./generic-repository";
import { lastValueFrom } from "rxjs";
import { MainComponent } from "../components/main/main.component";
import { ZonaModel } from "../services/zones/models/zona.model";
import { SsoRepository } from "./sso-repository";
import { BdtRepository } from "./bdt-repository";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ZonesRepository extends GenericRepository<ZonaModel> {
  public constructor(
    private http: HttpClient,
    private ssoRepo: SsoRepository,
    private bdtRepo: BdtRepository
  ) {
    super();
    this.fetch();
  }

  public fetch(): void {
    this.bdtRepo.getRecursos(BdtResources.Edificios)
      .then(() => {
        const apiUrl = `${this.ssoRepo.getTicket().UrlApi}/api/zonas/${this.ssoRepo.getTicket().Empresa.IdGestion}`;
        return lastValueFrom(this.http.get<ZonaModel[]>(apiUrl));
      })
      .then(result => {
        if (!result) return;
        result.forEach(zone => this.processZone(zone));
        this.setData(result);
      })
      .catch(error => console.error('Error fetching zones:', error));
  }

  private processZone(zone: ZonaModel): void {
    zone.EntradasCount = 0;
    zone.SalidasCount = 0;
    zone.EntradasSalidasCount = 0;

    zone.Entradas?.forEach(entrada => {
      switch (entrada.Tipo) {
        case 1:
          zone.EntradasCount++;
          break;
        case 2:
          zone.SalidasCount++;
          break;
        default:
          zone.EntradasSalidasCount++;
      }
    });

    zone.TipoGeoNombre = this.getGeoTypeName(zone.TipoGeo);
    zone.TipoNombre = this.getZoneTypeName(zone);
  }

  private getGeoTypeName(tipoGeo: number): string {
    return tipoGeo === 0 ? AppComponent.translate('Circulo') : AppComponent.translate('Poligono');
  }

  private getZoneTypeName(zone: ZonaModel): string {
    if (zone.Tipo === MasterType.EDIFICIOS && zone.TipoBDT !== 0) {
      return BdtRepository.recursos.get(zone.TipoBDT)?.Nombre || '';
    }

    const zoneNames: Record<number, string> = {
      [MasterType.ZONAADMIN]: 'Zonas_administrativas',
      [MasterType.MANUAL]: 'Manual',
      [MasterType.ELEMENTO]: 'Asociada_elemento',
      [MasterType.EDIFICIOS]: 'Edificios_instalaciones',
    };

    return MainComponent.getInstance().translate(zoneNames[zone.Tipo] || '');
  }

  public save(item: ZonaModel): void {
    throw new Error("Method not implemented.");
  }

  public update(item: ZonaModel): void {
    throw new Error("Method not implemented.");
  }

  public delete(id: number): void {
    throw new Error("Method not implemented.");
  }
}
